<template>
  <div style="width: 85%; margin: auto; padding-top: 10px; color: #7b7c87">
    <v-layout row wrap>
      <v-flex
        xs12
        md12
        lg12
        xl12
        style="padding: 15px; padding-bottom: 2px !important"
      >
        <!--Row #1-->
        <v-layout row wrap>
          <v-flex
            xs12
            sm12
            md10
            lg10
            xl10
            style="padding: 15px; padding-bottom: 0px"
          >
            <div
              style="padding-top: 23px; font-weight: bolder; font-size: 20px"
            >
              مدیریت محصولات فیزیکی
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-stepper non-linear v-model="NewProductStep">
              <v-stepper-header
                style="background-color: #262d47; color: orange"
              >
                <v-stepper-step
                  editable
                  edit-icon="fa fa-spinner"
                  color="orange"
                  :complete="NewProductStep > 1"
                  step="1"
                >
                  &nbsp;
                  <span style="color: orange">اطلاعات پایه</span> &nbsp;
                </v-stepper-step>
                <v-stepper-step
                  editable
                  edit-icon="fa fa-spinner"
                  color="orange"
                  :complete="NewProductStep > 2"
                  step="2"
                >
                  &nbsp;
                  <span style="color: orange">چندرسانه ای</span> &nbsp;
                </v-stepper-step>
                <v-stepper-step
                  editable
                  edit-icon="fa fa-spinner"
                  color="orange"
                  :complete="NewProductStep > 3"
                  step="3"
                >
                  &nbsp;
                  <span style="color: orange">تکمیلی</span> &nbsp;
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-content step="1"
                ><!--Product Base Information-->
                <v-form ref="PrdBaseInfo">
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 20px">
                      <v-autocomplete
                        v-for="i in MAXCATLEVELCOUNT"
                        :key="'newprodCatSelect' + i"
                        no-data-text="دسته بندی یافت نشد"
                        color="#2a2d45"
                        item-text="pC_Title"
                        item-value="pC_Id"
                        :items="NewProdCatItems['cat' + i]"
                        @input="NewProdCatChanged(i + 1, $event)"
                        @change="NewProdCatChanged(i + 1, $event)"
                        :label="'دسته بندی سطح ' + i"
                        outlined
                        dense
                        ref="TiggerChange"
                        v-model="NewProdCatModels['cat' + i]"
                      ></v-autocomplete>

                      <v-autocomplete
                        item-text="b_Title"
                        item-value="b_Id"
                        :items="BrandItems"
                        v-model="productBrand"
                        no-data-text="برند موجود نیست"
                        color="#2a2d45"
                        outlined
                        dense
                        label="انتخاب برند"
                      ></v-autocomplete>

                      <v-autocomplete
                        multiple
                        item-text="l_Title"
                        item-value="l_Id"
                        :items="LabelItems"
                        v-model="productLabel"
                        no-data-text="برچسب موجود نیست"
                        color="#2a2d45"
                        outlined
                        dense
                        label="برچسب نمایشی"
                      ></v-autocomplete>

                      
                      <v-text-field
                        color="#2a2d45"
                        style="direction:rtl !important"
                        v-model="productCode"
                        outlined
                        dense
                        label="کد محصول "
                      ></v-text-field>
                   
                      <v-text-field
                        color="#2a2d45"
                        style="direction:rtl !important"
                        v-model="productTitle"
                        outlined
                        dense
                        label="عنوان محصول "
                      ></v-text-field>
                      <v-text-field color="#2a2d45"  v-model="productDetailTitle" outlined dense label=" عنوان در توضیحات "></v-text-field>
                      <v-text-field
                        color="#2a2d45"
                        v-model="Psort"
                        outlined
                        dense
                        label=" ترتیب نمایش "
                      ></v-text-field>
                     
                      <v-text-field
                        color="#2a2d45"
                        v-model="manualRate"
                        outlined
                        dense
                        label=" امتیاز "
                      ></v-text-field>

                      <!-- 

                      <v-text-field color="#2a2d45"  v-model="productDetailSubTitle" outlined dense label=" زیر عنوان جزئیات "></v-text-field> -->
                      <v-text-field
                        color="#2a2d45"
                        v-model="productWeight"
                        outlined
                        dense
                        label=" وزن محصول "
                      ></v-text-field>
                      <v-text-field
                        color="#2a2d45"
                        v-model="productVolume"
                        outlined
                        dense
                        label=" حجم محصول "
                      ></v-text-field>
                      <v-text-field
                        color="#2a2d45"
                        style="direction:ltr !important"
                        v-model="ExternalLink"
                        v-if="ExternalSale"
                        outlined
                        dense
                        label="لینک خارجی محصول"
                      ></v-text-field>
                     <f-up ref="MainImg" :DeletePhoto="ResetUploader" :OldFile="OldFile" @RetunedFileName="GetUploadedFileName" Root="ELOGO" Folder="PRDIMG" BtnTitle="عکس محصول"></f-up>
                     <f-up  :OldFile="Gif" @RetunedFileName="Gif = $event" Root="ELOGO" Folder="PRDIMG" BtnTitle="عکس متحرک"></f-up>
                     <v-row>
                      <v-col cols="8">فروش در فروشگاه های دیگر :</v-col>
                      <v-col
                        cols="4"
                        style="display: flex; justify-content: flex-end"
                      >
                        <v-switch
                          v-model="ExternalSale"
                          style=" padding-top: 0px !important; margin-top: 0px !important; "
                          color="#2a2d45"
                        ></v-switch>
                      </v-col>
                    </v-row>
                      <v-row>
                        <v-col cols="8">وضعیت :</v-col>
                        <v-col
                          cols="4"
                          style="display: flex; justify-content: flex-end"
                        >
                          <v-switch
                            v-model="ProdStatus"
                            style=" padding-top: 0px !important; margin-top: 0px !important; "
                            color="#2a2d45"
                          ></v-switch>
                        </v-col>
                      </v-row>

                      <v-btn
                        @click="NewProductStep++"
                        outlined
                        dark
                        block
                        color="blue"
                      >
                        <v-icon small style="padding-left: 5px"
                          >fa fa-chevron-left</v-icon
                        >&nbsp; بعدی
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 md8 lg8 xl8 style="padding: 20px">
                      <seo-form
                        FileLoc="PRDCATSEOIMG"
                        :Seo="PrdSeoModel"
                        @SeoData="SeoChanged"
                      ></seo-form>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="2"
                ><!--Product Multimedia-->
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm4
                        md2
                        lg2
                        xl2
                        v-for="item in imageItems"
                        :key="item"
                        style="padding: 20px"
                      >
                        <v-card>
                          <v-overlay style="padding: 0px" absolute
                            ><v-btn small text @click="deleteImageItem(item)"
                              ><v-icon small>fa fa-trash</v-icon></v-btn
                            ></v-overlay
                          >
                          <v-img :src="UploadedProductIgGallery + item" />
                        </v-card>
                      </v-flex>
                      
                      <v-flex xs12 sm4 md2 lg2 xl2 style="padding: 20px">
                        <v-card>
                          <v-overlay style="padding: 0px" absolute>
                             <f-up :hideExternal="true" @RetunedFileName="PickImageName" Root="GALLERYCHILD" Folder="PRODUCTGALLERY" BtnTitle="عکس جدید"></f-up>
                            </v-overlay>
                          <v-img
                            contain
                            :src="require('../../../assets/blank-bg.png')"
                          />
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm12 lg12 xl12>
                        <v-row>
                          <v-col v-for="(item,index) in DetailImages" :key="index" cols="4">
                            <f-up :OldFile="DetailImages[index]" @RetunedFileName="DetailImages[index] = $event" Root="ELOGO" Folder="PRDIMG" :BtnTitle="'عکس توضیحات '+(index+1)"></f-up>
                          </v-col>
                          <v-col cols="4">
                            <file-upload :OldFile="Catalog" @RetunedFileName="Catalog = $event"  BtnTitle=" کاتالوگ"></file-upload>
                          </v-col>
                        </v-row>
                      </v-flex>
                      
                      <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                        <div class="videoHolderAndSelect">
                          <iframe
                            style="width: 100%;height: 100%;border: none;display: block;position: absolute;top: 0px;"
                            :src="aprtSrc"
                          ></iframe>
                          <v-overlay absolute>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12 lg12 xl12>
                                <div style="display: block; text-align: center">
                                  آیدی ویدئو آپارات را وارد نمایید.
                                </div>
                              </v-flex>
                              <v-flex xs3 sm3 md3 lg3 xl3>
                                <v-btn @click="checkAparatVideo" color="success">بررسی</v-btn>
                              </v-flex>
                              <v-flex xs9 sm9 md9 lg9 xl9>
                                <v-text-field
                                  v-model="PickVideoName"
                                  light
                                  hint="E2dXxفقط آیدی ویدئو را وارد نمایید. مانند    "
                                  style="direction : ltr;"
                                  dense
                                  solo
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-overlay>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                    <v-btn
                      @click="NewProductStep--"
                      outlined
                      dark
                      color="purple"
                    >
                      <v-icon small style="padding-left: 5px"
                        >fa fa-chevron-right</v-icon
                      >&nbsp; قبلی </v-btn
                    >&nbsp;
                    <v-btn @click="NewProductStep++" outlined dark color="blue">
                      <v-icon small style="padding-left: 5px"
                        >fa fa-chevron-left</v-icon
                      >&nbsp; بعدی
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
              <v-stepper-content step="3"
                ><!--Product Descriptions-->
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                    <div>توضیحات خلاصه</div>
                    <quill-editor :content="SummeryDescription"
                      @change="({html})=>{SummeryDescription = html}">
                    </quill-editor>
                  
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                    <div>توضیحات معرفی 1</div>
                    <quill-editor :content="ProductTechnicalInfo"
                      @change="({html})=>{ProductTechnicalInfo = html}">
                    </quill-editor>
                    
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                    <div>توضیحات معرفی 2</div>
                    <quill-editor :content="ProductDesc2"
                      @change="({html})=>{ProductDesc2 = html}">
                    </quill-editor>
                    
                  </v-flex>
                
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                    <v-btn
                      @click="NewProductStep--"
                      outlined
                      dark
                      color="purple"
                    >
                      <v-icon small style="padding-left: 5px"
                        >fa fa-chevron-right</v-icon
                      >&nbsp; قبلی </v-btn
                    >&nbsp;
                    <v-btn @click="SaveProduct" outlined dark color="blue">
                      <v-icon small style="padding-left: 5px"
                        >fa fa-check</v-icon
                      >&nbsp; ذخیره
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 15px"> <!--Operation Button And Category Selection Holder-->
        <div class="operationBoxDesign">
          <v-layout row wrap>
            <v-flex xs12 sm12 md5 lg5 xl5 style="padding:20px">
              <v-text-field outlined dense v-model="srchPrdTitle" color="#2a2d45" label="عنوان محصول"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md5 lg5 xl5 style="padding:20px">
              <v-text-field outlined dense v-model="srchPrdCode" color="#2a2d45" label="کد  محصول"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md2 lg2 xl2 style="padding:20px">
              <v-btn outlined @click="SearchProducts" color="blue" block><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div class="operationBoxDesign">
          <div
            class="OperationBoxColumns"
            v-for="i in MAXCATLEVELCOUNT"
            :key="'catselectionholder' + i"
          >
            <v-autocomplete
              no-data-text="دسته بندی یافت نشد"
              color="#2a2d45"
              item-text="pC_Title"
              item-value="pC_Id"
              :items="FooterCategoryItems['cat' + i]"
              @change="FooterCatSelectionChanged(i + 1, $event)"
              :label="'دسته بندی سطح ' + i"
              outlined
              dense
              v-model="FooterCategoryModel['cat' + i]"
            ></v-autocomplete>
            
          </div>
          <div class="OperationBoxColumns">
            <v-autocomplete
              no-data-text="برند یافت نشد"
              color="#2a2d45"
              item-text="b_Title"
              item-value="b_Id"
              :items="BrandItems"
              v-model="filterByBrandId"
              label="برند"
              outlined
              dense
              @change="loadProducts(selectedEndlvlCat)"
            ></v-autocomplete>
          </div>
        </div>
        
        <div class="operationBoxDesign" >
          <v-btn
            class="operationBoxButton"
            outlined
            color="rgb(173, 20, 87)"
            dark
            @click="ChangePriceDlg = true"
          >
            <v-icon small style="padding-left: 5px">fa fa-funnel-dollar</v-icon
            >&nbsp;تغییر قیمت
          </v-btn>
          <v-btn v-if="10 == 4" class="operationBoxButton" outlined color="#4CAF50" dark>
            <v-icon small style="padding-left: 5px">fa fa-percent</v-icon
            >&nbsp;اعمال تخفیف
          </v-btn>
          <v-btn v-if="10 == 4" class="operationBoxButton" outlined color="error" dark>
            <v-icon small style="padding-left: 5px">fa fa-eraser</v-icon
            >&nbsp;حذف تخفیف
          </v-btn>
           <v-autocomplete
           style="height:37px !important"
                        item-text="b_Title"
                        item-value="b_Id"
                        :items="BrandItems"
                        v-model="selectedBrandId"
                        no-data-text="برند موجود نیست"
                        color="#2a2d45"
                        outlined
                        dense
                        label="انتخاب برند"
                      ></v-autocomplete>
          <v-btn @click="ExportExcelByCat" class="operationBoxButton" outlined color="#2a2d45" dark>
            <v-icon small style="padding-left: 5px">fa fa-file-export</v-icon
            >&nbsp;دریافت اکسل
          </v-btn>
          <v-btn v-if="10 == 4" class="operationBoxButton" outlined color="#2a2d45" dark>
            <v-icon small style="padding-left: 5px">fa fa-file-import</v-icon
            >&nbsp;بروزرسانی اکسل
          </v-btn>
        </div>
        <v-card>
          <v-card-text>
            <v-data-table
              :loading="isLoadingProducts"
              loading-text="در حال بارگزاری داده ها ، لطفا صبر کنید..."
              :items="productTableItems"
              :headers="productTableHeader"
              items-per-page-text="تعداد در هر صفحه"
              no-data-text="رکوردی یافت نشد"
              no-results-text="رکوردی یافت نشد"
              :footer-props="{
                'items-per-page-text': 'آیتم در هر صفحه :',
                'items-per-page-all-text': 'همه',
              }"
            >
              <template v-slot:[`item.p_Discount`]="{ item }">
                {{ item.p_Discount }}
                <strong v-if="item.p_DiscountType == 1" style="color: blue"
                  >%</strong
                >
                <strong v-else style="color: red"> ریال </strong>
              </template>
              <template v-slot:[`item.p_Image`]="{ item }">
                <v-btn
                  target="_blank"
                  :href="productMainImageDownloadUrl + `${item.p_Image}`"
                  icon
                  small
                  ><v-icon small>fas fa-eye</v-icon></v-btn
                >
              </template>
              <template v-slot:[`item.p_Status`]="{ item }">
                <v-btn
                  small
                  text
                  color="#D32F2F"
                  @click="ActiveItem(item.p_Id)"
                  dark
                  v-if="!item.p_Status"
                  >غیر فعال</v-btn
                >
                <v-btn
                  small
                  text
                  color="#2E7D32"
                  @click="DisableItem(item.p_Id)"
                  dark
                  v-else
                >
                  فعال</v-btn
                >
              </template>
              <template v-slot:[`item.operation`]="{ item }">
                <v-btn
                  text
                  icon
                  small
                  color="#010cb1"
                  @click="editItem(item)"
                  ><v-icon small>fas fa-edit</v-icon></v-btn
                >
                <v-tooltip top color="#48c9ef">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="#48c9ef"
                      @click="SetExpertReview(item.p_Id)"
                      ><v-icon small>fa fa-swatchbook</v-icon></v-btn
                    >
                  </template>
                  <span>نقد و بررسی تخصصی</span>
                </v-tooltip>
                <v-tooltip top color="orange">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="orange"
                      @click="ProductAttributes(item.p_Id,item.p_Title)"
                      ><v-icon small>fas fa-layer-group</v-icon></v-btn
                    >
                  </template>
                  <span>فیلد های اختصاصی</span>
                </v-tooltip>
                <v-tooltip v-if="!item.p_ExternalSale" top color="#2a87dd">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="#2a87dd"
                      @click="Combine(item)"
                      ><v-icon small>fas fa-compress-arrows-alt</v-icon></v-btn
                    >
                  </template>
                  <span>تنوع محصول</span>
                </v-tooltip>

                <v-tooltip top color="#0d7084">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="#0d7084"
                      @click="SetPerfect(item.p_Id)"
                      ><v-icon small>fas fa-link</v-icon></v-btn
                    >
                  </template>
                  <span>محصولات مکمل</span>
                </v-tooltip>

               

                
                <v-tooltip top color="red">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="red"
                      @click="SetGiftProducts(item.p_Id)"
                      ><v-icon small>fas fa-gift</v-icon></v-btn
                    >
                  </template>
                  <span> محصول هدیه</span>
                </v-tooltip>
              
                <v-btn
                  text
                  icon
                  small
                  color="red accent-4"
                  @click="confirmDeleteItem(item.p_Id)"
                  ><v-icon small>fas fa-trash</v-icon></v-btn
                >&nbsp;
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <template>
      <!--Loading Dialog-->
      <div class="vld-parent">
        <loading
          color="#f75314"
          :width="parseInt(45)"
          :height="parseInt(45)"
          background-color="#fff"
          :active.sync="isLoading"
          :is-full-page="true"
        ></loading>
      </div>
    </template>
    <template><!--Delete Confirm Dialog-->
      <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
        <v-card>
          <v-card-title style="padding: 0px !important">
            <v-app-bar dense color="rgb(42, 45, 69)" dark>
              <v-toolbar-title style="color: orange">حذف دائمی</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon
                color="orange"
                @click="ConfirmItemDeleteDialog = false"
                small
                >fa fa-times</v-icon
              >
            </v-app-bar>
          </v-card-title>
          <v-card-text style="padding-top: 15px">
            <v-alert type="error" outlined>
              کاربر گرامی ؛ رکورد مورد نظر به صورت دائمی حذف خواهد شد.ادامه
              میدهید؟
            </v-alert>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn outlined color="error" @click="DeleteItem"
              ><v-icon small style="padding-left: 5px">fa fa-trash</v-icon
              >&nbsp; بله</v-btn
            >&nbsp;
            <v-btn
              outlined
              @click="ConfirmItemDeleteDialog = false"
              color="info"
              ><v-icon small style="padding-left: 5px">fa fa-times</v-icon
              >&nbsp; خیر</v-btn
            >&nbsp;
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template><!--Related product selection dialog-->
      <v-dialog fullscreen persistent v-model="RelatedProductDialog">
        <v-card>
          <v-card-title style="padding: 0px !important">
            <v-app-bar dense color="rgb(42, 45, 69)" dark>
              <v-toolbar-title style="color: orange">
                <span>محصولات مرتبط</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="orange" @click="RelatedProductDialog = false" small
                >fa fa-times</v-icon
              >
            </v-app-bar>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined v-model="RelationProductsSearchByPName" dense label="نام محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined dense v-model="RelationProductsSearchByPCode" label="کد محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-btn @click="loadProductsForRelation(1)" outlined block color="rgb(42, 45, 69)"><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <div class="d-flex justify-center align-center cpation font-weight-black">همه محصولات</div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items-per-page="PageSize" :items="RelationAllProductTableItems" hide-default-footer :headers="RelationTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="ShiftToRelTabl(item)" color="green accent-4"><v-icon color="#fff" x-small>fa fa-plus</v-icon></v-btn>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col cols="10"><v-pagination @input="RelProdTableJumpToPage($event)" v-model="CurrentPage" color="orange" :length="PageCounts" total-visible></v-pagination></v-col>
                  <v-col cols="2"><v-select @change="loadProductsForRelation(1)" label="تعداد آیتم در صفحه" :items="PageSizeItems" item-text="text" item-value="value" outlined dense v-model="PageSize"></v-select></v-col>
                </v-row>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px" class="flex-row d-flex justify-sm-space-between">
                <div class="d-flex justify-center align-center cpation font-weight-black">محصولات زیر مجموعه</div>
                <v-btn outlined color="green" @click="SaveProductRelations()"><v-icon small style="padding-left:5px">fa fa-check</v-icon>بروزرسانی</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items="RelTableItems" :headers="RelationTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="DeleteFromRelTable(item)" color="red accent-4"><v-icon color="#fff" x-small>fa fa-minus</v-icon></v-btn>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template><!--Set products selection dialog-->
      <v-dialog fullscreen persistent v-model="SetProductDialog">
        <v-card>
          <v-card-title style="padding: 0px !important">
            <v-app-bar dense color="rgb(42, 45, 69)" dark>
              <v-toolbar-title style="color: orange">
                <span>محصولات ست</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="orange" @click="SetProductDialog = false" small
                >fa fa-times</v-icon
              >
            </v-app-bar>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined v-model="SetProductsSearchByPName" dense label="نام محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined dense v-model="SetProductsSearchByPCode" label="کد محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-btn @click="loadProductsForSet(1)" outlined block color="rgb(42, 45, 69)"><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <div class="d-flex justify-center align-center cpation font-weight-black">همه محصولات</div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items-per-page="PageSizeSet" :items="SetAllProductTableItems" hide-default-footer :headers="RelationTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="ShiftToSetTabl(item)" color="green accent-4"><v-icon color="#fff" x-small>fa fa-plus</v-icon></v-btn>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col cols="10"><v-pagination @input="SetProdTableJumpToPage($event)" v-model="CurrentPageSet" color="orange" :length="PageCountsSet" total-visible></v-pagination></v-col>
                  <v-col cols="2"><v-select @change="loadProductsForSet(1)" label="تعداد آیتم در صفحه" :items="PageSizeItems" item-text="text" item-value="value" outlined dense v-model="PageSizeSet"></v-select></v-col>
                </v-row>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px" class="flex-row d-flex justify-sm-space-between">
                <div class="d-flex justify-center align-center cpation font-weight-black">محصولات زیر مجموعه</div>
                <v-btn outlined color="green" @click="SaveProductSet()"><v-icon small style="padding-left:5px">fa fa-check</v-icon>بروزرسانی</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items="SetTableItems" :headers="RelationTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="DeleteFromSetTable(item)" color="red accent-4"><v-icon color="#fff" x-small>fa fa-minus</v-icon></v-btn>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template><!--PRODUCT COMBINE -->
      <v-dialog fullscreen persistent v-model="CombineDialog">
        <v-card>
          <v-card-title style="padding: 0px !important">
           <v-app-bar dense color="rgb(42, 45, 69)" dark>
              <v-toolbar-title style="color: orange"
                >تنوع محصول - 
                {{ CombineProductTitle }}</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-icon color="orange" @click="CloseCombine" small
                >fa fa-times</v-icon
              >
            </v-app-bar>
            
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding: 20px">
                
                 <v-autocomplete
                  :label="i.title"
                  v-for="(i,index) in ValueableAttributes"
                  :key="index"
                  :items="i.answers"
                  v-model="ValueableAttributeModel[index].valueableAnswerId"
                  item-text="title"
                  item-value="id"
                  outlined
                  dense
                ></v-autocomplete>
                <!-- v-if="ValueableAttributes.length > 0 && ValueableAttributes.some(el => el.colorable == true)" -->
                <f-up   :OldFile="CombineImage" @RetunedFileName="CombineImage = $event" Root="ELOGO" Folder="PRDIMG" BtnTitle="عکس محصول"></f-up>
                <v-text-field
                  label="عنوان"
                  v-model="CombineTitle"
                  outlined
                  dense
                ></v-text-field>
               <v-text-field
                  label="ترتیب نمایش"
                  v-model="CombineSort"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  label="قیمت"
                  v-model="CombineP"
                  type="number"
                  step="0.001"
                  persistent-hint
                  :hint="currencyFormat(CombineP)"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  label="وزن"
                  v-model="CombineW"
                  type="number"
                  step="1"
                  persistent-hint
                  :hint="currencyFormat(CombineW)"
                  outlined
                  dense
                ></v-text-field>
                 <v-text-field
                  label="موجودی"
                  v-model="CombineAvl"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  :label="CombinePriceType ? `قیمت درصدی` : `قیمت منهای تخفیف`"
                  v-model="CombineD"
                  type="number"
                  outlined
                  persistent-hint
                  :hint="currencyFormat(CombineD)"
                  dense
                ></v-text-field>
                <v-row>
                  <v-col cols="8">نوع تخفیف :</v-col>
                  <v-col
                    cols="4"
                    style="display: flex; justify-content: flex-end"
                  >
                    <v-switch
                      v-model="CombinePriceType"
                      style="padding-top: 0px !important;margin-top: 0px !important;"
                      color="#2a2d45"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">پیشفرض :</v-col>
                  <v-col
                    cols="4"
                    style="display: flex; justify-content: flex-end"
                  >
                    <v-switch
                      v-model="CombineDefault"
                      style=" padding-top: 0px !important; margin-top: 0px !important; "
                      color="#2a2d45"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">وضعیت :</v-col>
                  <v-col
                    cols="4"
                    style="display: flex; justify-content: flex-end"
                  >
                    <v-switch
                      v-model="CombineState"
                      style="padding-top: 0px !important; margin-top: 0px !important;" color="#2a2d45"
                    ></v-switch>
                  </v-col>
                </v-row>

                <v-btn outlined block color="blue" @click="SaveCombine"
                  ><v-icon small style="padding-left: 5px">fa fa-check</v-icon
                  >ذخیره</v-btn
                >
              </v-flex>
              <v-flex xs12 sm12 md8 lg8 xl8 style="padding: 20px">
                <v-data-table
                  :items="CombineTableItems"
                  :headers="CombineTableHeaders"
                >
                  <template v-slot:[`item.x_Discount`]="{ item }">
                    <v-chip
                      dark
                      color="green"
                      small
                      v-if="item.x_DiscountType == 2"
                      >{{ item.x_Discount }}</v-chip
                    >
                    <v-chip dark color="blue" small v-else
                      >{{ item.x_Discount }} %</v-chip
                    >
                  </template>
                  <template v-slot:[`item.x_Default`]="{ item }">
                    <v-chip dark color="green" small v-if="item.x_Default"
                      >بله</v-chip
                    >
                    <v-chip dark color="gray" small v-else>خیر</v-chip>
                  </template>
                  <template v-slot:[`item.x_Status`]="{ item }">
                    <v-btn
                      small
                      text
                      color="#D32F2F"
                      @click="ActiveCombineItem(item.x_Id)"
                      dark
                      v-if="!item.x_Status"
                      >غیر فعال</v-btn
                    >
                    <v-btn
                      small
                      text
                      color="#2E7D32"
                      @click="DisableCombineItem(item.x_Id)"
                      dark
                      v-else
                    >
                      فعال</v-btn
                    >
                  </template>
                  <template v-slot:[`item.operation`]="{ item }">
                    <v-btn
                      text
                      icon
                      small
                      color="blue accent-4"
                      @click="editCombineItem(item)"
                      ><v-icon small>fas fa-edit</v-icon></v-btn
                    >
                    <v-btn
                      text
                      icon
                      small
                      color="red accent-4"
                      @click="DeleteCombineItem(item.x_Id)"
                      ><v-icon small>fas fa-trash</v-icon></v-btn
                    >&nbsp;
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="ProductAttributeDialog" fullscreen persistent>
        <v-card>
            <v-card-title style="padding: 0px !important">
              <v-app-bar dense color="rgb(42, 45, 69)" dark>
                <v-toolbar-title style="color: orange">فیلد های اختصاصی محصول - {{prdTitle}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon
                  color="orange"
                  @click="ProductAttributeDialog = false"
                  small
                  >fa fa-times</v-icon
                >
              </v-app-bar>
            </v-card-title>
            <v-card-text style="padding-top: 10px">
              <v-btn outlined color="green" dark @click="SetProductAttributes">
                <v-icon small style="padding-left: 5px">fa fa-update</v-icon>&nbsp;بروزرسانی
              </v-btn>
              <v-data-table :items="ProductAttributeList" :headers="ProductattributeTableHeader">
                  <template v-slot:[`item.ans`]="{item}">
                    <div style="padding-top:10px">
                      <v-autocomplete outlined dense v-if="item.type == 1" v-model="item.value" :items="item.answers" item-text="text" item-value="value"></v-autocomplete>
                      <v-textarea style="direction:rtl !important" outlined dense v-if="item.type == 2" v-model="item.value"></v-textarea>
                    </div>
                  </template>
              </v-data-table>
            </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="ChangePriceDlg" max-width="400px">
        <v-card>
          <v-card-title>
            <span class="font-weight-bold" style="font-size:14px" >تغییر قیمت محصولات</span>
            <v-spacer></v-spacer>
            <v-icon small color="red" @click="ChangePriceDlg = false">fa fa-times</v-icon>
          </v-card-title>
          <v-card-text>
            <v-text-field persistent-hint dense outlined label="مقدار" hint="مقدار باید مضرب اعشار دار باشد - برای مثال 1.1 به معنی 10 درصد است" v-model="PercToIncDec"></v-text-field>
          </v-card-text>
          <v-card-actions>
                <v-btn @click="IncreasePrice" small color="green" dark>
                  <v-icon class="pl-5" small color="#fff">
                    fa fa-chevron-up
                  </v-icon>
                  افزایش
                </v-btn>
                <v-btn @click="DecreasePrice" small color="red" dark>
                  <v-icon class="pl-5" small color="#fff">
                    fa fa-chevron-down
                  </v-icon>
                  کاهش
                </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template
    ><!--Gift products selection dialog-->
    <v-dialog fullscreen persistent v-model="GiftProductDialog">
      <v-card>
        <v-card-title style="padding: 0px !important">
          <v-app-bar dense color="rgb(42, 45, 69)" dark>
            <v-toolbar-title style="color: orange">
              <span>محصول هدیه</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon color="orange" @click="GiftProductDialog = false" small
              >fa fa-times</v-icon
            >
          </v-app-bar>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
              <v-text-field outlined v-model="GiftProductsSearchByPName" dense label="نام محصول"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
              <v-text-field outlined dense v-model="GiftProductsSearchByPCode" label="کد محصول"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
              <v-btn @click="loadProductsForGift(1)" outlined block color="rgb(42, 45, 69)"><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
              <div class="d-flex justify-center align-center cpation font-weight-black">همه محصولات</div>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
              <v-data-table :items-per-page="PageSizeGift" :items="GiftAllProductTableItems" hide-default-footer :headers="RelationTableHeader">
                <template v-slot:[`item.operation`]="{item}">
                  <v-btn x-small @click="ShiftToGiftTabl(item)" color="green accent-4"><v-icon color="#fff" x-small>fa fa-plus</v-icon></v-btn>
                </template>
              </v-data-table>
              <v-row>
                <v-col cols="10"><v-pagination @input="GiftProdTableJumpToPage($event)" v-model="CurrentPageGift" color="orange" :length="PageCountsGift" total-visible></v-pagination></v-col>
                <v-col cols="2"><v-select @change="loadProductsForGift(1,true)" label="تعداد آیتم در صفحه" :items="PageSizeItems" item-text="text" item-value="value" outlined dense v-model="PageSizeGift"></v-select></v-col>
              </v-row>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px" class="flex-row d-flex justify-sm-space-between">
              <div class="d-flex justify-center align-center cpation font-weight-black">محصولات زیر مجموعه</div>
              <v-btn outlined color="green" @click="SaveProductGift()"><v-icon small style="padding-left:5px">fa fa-check</v-icon>بروزرسانی</v-btn>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
              <v-data-table :items="GiftTableItems" :headers="GiftTableHeader">
                <template v-slot:[`item.operation`]="{item}">
                  <v-btn x-small @click="DeleteFromGiftTable(item)" color="red accent-4"><v-icon color="#fff" x-small>fa fa-minus</v-icon></v-btn>
                </template>
                <template v-slot:[`item.newtitle`]="{item}">
                  <v-text-field outlined dense v-model="item.newtitle" label="عنوان"></v-text-field>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  <template
  ><!--Perfect product selection dialog-->
  <v-dialog fullscreen persistent v-model="PerfectProductDialog">
    <v-card>
      <v-card-title style="padding: 0px !important">
        <v-app-bar dense color="rgb(42, 45, 69)" dark>
          <v-toolbar-title style="color: orange">
            <span>محصولات مکمل</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon color="orange" @click="PerfectProductDialog = false" small
            >fa fa-times</v-icon
          >
        </v-app-bar>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
            <v-text-field outlined v-model="PerfectProductsSearchByPName" dense label="نام محصول"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
            <v-text-field outlined dense v-model="PerfectProductsSearchByPCode" label="کد محصول"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
            <v-btn @click="loadProductsForPerfect(1)" outlined block color="rgb(42, 45, 69)"><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
            <div class="d-flex justify-center align-center cpation font-weight-black">همه محصولات</div>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
            <v-data-table :items-per-page="PageSizePerfect" :items="PerfectAllProductTableItems" hide-default-footer :headers="RelationTableHeader">
              <template v-slot:[`item.operation`]="{item}">
                <v-btn x-small @click="ShiftToPerfectTabl(item)" color="green accent-4"><v-icon color="#fff" x-small>fa fa-plus</v-icon></v-btn>
              </template>
            </v-data-table>
            <v-row>
              <v-col cols="10"><v-pagination @input="PefrectProdTableJumpToPage($event)" v-model="CurrentPagePerfect" color="orange" :length="PageCountsPerfect" total-visible></v-pagination></v-col>
              <v-col cols="2"><v-select @change="loadProductsForPerfect(1)" label="تعداد آیتم در صفحه" :items="PageSizeItems" item-text="text" item-value="value" outlined dense v-model="PageSizePerfect"></v-select></v-col>
            </v-row>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px" class="flex-row d-flex justify-sm-space-between">
            <div class="d-flex justify-center align-center cpation font-weight-black">محصولات زیر مجموعه</div>
            <v-btn outlined color="green" @click="SaveProductPerfects()"><v-icon small style="padding-left:5px">fa fa-check</v-icon>بروزرسانی</v-btn>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
            <v-data-table :items="PerfectTableItems" :headers="RelationTableHeader">
              <template v-slot:[`item.operation`]="{item}">
                <v-btn x-small @click="DeleteFromPerfectTable(item)" color="red accent-4"><v-icon color="#fff" x-small>fa fa-minus</v-icon></v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

    <template
    ><!--Expert Review Selection dialog-->
    <v-dialog fullscreen persistent v-model="ExpertReviewDialog">
      <v-card>
        <v-card-title style="padding: 0px !important">
          <v-app-bar dense color="rgb(42, 45, 69)" dark>
            <v-toolbar-title style="color: orange">
              <span>نقد و بررسی تخصصی محصول</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon color="orange" @click="ExpertReviewDialog = false" small
              >fa fa-times</v-icon
            >
          </v-app-bar>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md8 lg4 xl4 style="padding:20px">
              <v-text-field outlined v-model="ExpertTitle" dense label="عنوان"></v-text-field>
              <v-text-field outlined v-model="ExpertSort" dense label="ترتیب نمایش"></v-text-field>
              <quill-editor placeholder="توضیحات" :content="ExpertDescription"
                                  @change="({html})=>{ExpertDescription = html}">
                                  </quill-editor>
              <f-up :OldFile="ImageUrl" @RetunedFileName="ImageUrl = $event" Root="ELOGO" Folder="PRDIMG" BtnTitle="عکس محصول"></f-up>
              <v-row>
                <v-col cols="8">وضعیت :</v-col>
                <v-col cols="4" style="display: flex; justify-content: flex-end">
                  <v-switch v-model="ExpertStatus" style="padding-top: 0px !important;margin-top: 0px !important;" color="#2a2d45"></v-switch>
                </v-col>
              </v-row>
              <v-btn @click="SaveExpertReview" outlined dark color="blue">
                    <v-icon small style="padding-left: 5px">fa fa-check</v-icon>&nbsp; ذخیره
              </v-btn>&nbsp;
              <v-btn @click="cancelEditExpert" v-if="InEditingExpert" outlined dark color="red">
                    <v-icon small style="padding-left: 5px">fa fa-clear</v-icon>&nbsp; خروج از حالت ویرایش
              </v-btn>
            </v-flex>
            <v-flex xs12 sm12 md8 lg8 xl8 style="padding:20px">
              <v-data-table :items="ExpertTableItems" :headers="ExpertTableHeaders">
                <template v-slot:[`item.operation`]="{item}">
                  <v-btn
                    text
                    icon
                    small
                    color="#010cb1"
                    @click="editExpert(item)"
                    ><v-icon small>fas fa-edit</v-icon></v-btn
                  >&nbsp;
                  <v-btn
                    text
                    icon
                    small
                    color="red accent-4"
                    @click="deleteExpert(item.e_Id)"
                    ><v-icon small>fas fa-trash</v-icon></v-btn
                  >
                </template>
                <template v-slot:[`item.e_Status`]="{item}">
                  <v-btn
                    small
                    text
                    color="#D32F2F"
                    @click="ActiveExpert(item.e_Id)"
                    dark
                    v-if="!item.e_Status"
                    >غیر فعال</v-btn
                  >
                  <v-btn
                    small
                    text
                    color="#2E7D32"
                    @click="DisableExpert(item.e_Id)"
                    dark
                    v-else
                  >
                    فعال</v-btn
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>

  </div>
</template>
<script>
function moneyFormat(price, sign = '') {
  const pieces = parseFloat(price).toFixed(2).split('')
  let ii = pieces.length - 3
  while ((ii-=3) > 0) {
    pieces.splice(ii, 0, ',')
  }
  var str = sign + pieces.join('');
  str = str.replace('.0','').replace('.00','');
  str = str.substring(0, str.length - 1);
  return str;
}
const axios = require("axios");
const ApiUrl = require("../../../constant/apiurl");
const MSGHNDL = require("../../../constant/MessageHandler");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import JsonExcel from "vue-json-excel";
const FTYPES = require("../../../constant/setting/Default/AllowedFileTypes");
const FSIZE = require("../../../constant/setting/Default/AllowedFileSize");
import { VueEditor } from "vue2-editor";
import Vue from 'vue';
export default {
  name: "product",
  components: {
    Loading,
    JsonExcel,
    VueEditor
  },
  data: () => ({
    ///Gift Product
    GiftProductDialog:false,
    GiftProductsSearchByPName:"",
    GiftProductsSearchByPCode:"",
    GiftAllProductTableItems:[],
    GiftTableItems:[],
    CurrentPageGift : 0,
    PageCountsGift: 0 ,
    PageSizeGift: 5,
    ///
    PercToIncDec:0,
    ChangePriceDlg:false,
    selectedBrandId:0,
    selectedEndlvlCat:0,
    prdTitle:"",
    CombineDialog: false,
    CombineDefault: false,
    CombinePriceType: true,
    CombineState: true,
    CombineProductId: 0,
    CombineProductTitle: "",
    WarrantyItems: [],
    ColorItems: [],
    CombineW: 0,
    CombineC: "",
    CombineP: 0,
    CombineGem:0,
    CombineD: 0,
    CombineSort: 1,
    CombineTitle:"",
    CombineTableHeaders: [
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "قیمت", value: "x_Price", sortable: true, align: "right" },
      { text: "تخفیف", value: "x_Discount", sortable: true, align: "right" },
      { text: "ترتیب نمایش", value: "x_Sort", sortable: true, align: "right" },
      { text: "پیشفرض", value: "x_Default", sortable: true, align: "right" },
      { text: "وضعیت", value: "x_Status", sortable: true, align: "right" },
      { text: "عملیات", value: "operation", sortable: true, align: "right" },
    ],
    CombineTableItems: [],
    EditCombineId: "",
    InEditingCombineItem: false,

    isLoading: false,
    LEVELCOUNT: 1,
    MAXCATLEVELCOUNT: 0,
    CatSelectionModels: [],
    NewProdCatModels: [],
    RelatedCategoryModel: [],
    RelatedCategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    FooterCategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    CategoryItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    NewProdCatItems: {
      cat1: [],
      cat2: [],
      cat3: [],
      cat4: [],
      cat5: [],
      cat6: [],
      cat7: [],
      cat8: [],
      cat9: [],
      cat10: [],
      cat11: [],
      cat12: [],
      cat13: [],
      cat14: [],
      cat15: [],
      cat16: [],
      cat17: [],
      cat18: [],
      cat19: [],
      cat20: [],
    },
    FooterCategoryModel: [],
    NewProductDialog: true,
    inEditingItem: false,
    NewProductStep: 1,
    PrdSeoModel: {},
    editingItem: {},
    seo: {},
    BrandItems: [],
    LabelItems: [],
    ProdStatus: true,
    catLogoSelectionDialog: false,
    ALLOEWDIMGSIZE: {},
    ProductIntroduction: "",
    ProductTechnicalInfo: "",
    SummeryDescription:"",
    ProductDesc2:"",
    Attributes: [],
    DiscountType: true,
    productBrand: "",
    productLabel: [],
    productTitle: "",
    productIsbn: "",
    productDetailTitle: "",
    productDetailSubTitle: "",
    productPrice: 0,
    productDiscount: 0,
    productAmazonPrice: 0,
    RelationDataLoaded: false,
    productTableItems: [],
    productTableHeader: [
      { text: "کد", value: "p_Code", sortable: true, align: "right" },
      {
        text: "دسته بندی ",
        value: "p_CatTitle",
        sortable: true,
        align: "right",
      },
      { text: "عنوان ", value: "p_Title", sortable: true, align: "right" },
      { text: "ترتیب نمایش ", value: "p_Sort", sortable: true, align: "right" },
      { text: "عکس", value: "p_Image", sortable: true, align: "right" },
      { text: "وضعیت", value: "p_Status", sortable: true, align: "right" },
      { text: "عملیات", value: "operation", sortable: true, align: "right" },
    ],
    
    isLoadingProducts: false,
    productMainImageDownloadUrl: "",
    ConfirmItemDeleteDialog: false,
    deleteItemId: "",
    RelatedProductDialog: false,
    RelatedProductTableItems: [],
    isLoadingRelatedProducts: false,
    ProductToSelectRelation: 0,
    SelectedProductRelations: [],
    PRELATIONLASTCHANGE: [], //
    /**Multiple image uploader**/ imageItems: [],
    UploadedProductIgGallery: "",
    UploadProductGalleryChildUrl: "",
    SelectProductImageChild: false,
    UploadProductImgUrl: "",
    UploadProductImgEndPoint: "",
    UploadedProductIgEndPoint: "PRODUCTGALLERY",
    selectedLogoSource: "",
    catLogoData: "",
    AudioUrl: "",
    AudioFile: null,
    AudioFileAdrress: null,
    MainAudioFile: null,
    MainAudioFileAdrress: null,
    VideoName: "",
    productWeight: 0,
    productPageCount: 0,
    productDownloadLink: "",
    productIsPrintAble: true,
    productPrintAblePrice: 0,
    productBinPrice: 0,
    productPriceType: false,
    productPrintAblePriceType: false,
    productPeriodPriceType: false,
    FormulaItems: [],
    productPriceFormulaId: 0,
    productPeriodTime: 0,
    productPeriodTimePrice: 0,
    productPeriodFormulaId: 0,
    productVolume:0,
    productUniqueCode: "",
    aprtSrc: "",
    PickVideoName: "",
    manualRate: 0,
    CurrentPage:0,
    PageCounts:0,
    PageSize:5,
    CombineAvl:0,
    PageSizeItems:[
      {text:"5",value:5},
      {text:"10",value:10},
      {text:"20",value:20},
      {text:"40",value:40},
      {text:"100",value:100},
      {text:"200",value:200},
      {text:"500",value:500},
      {text:"1000",value:1000}
    ],
    RelationProductsSearchByPName:"",
    RelationProductsSearchByPCode:"",
    RelationAllProductTableItems:[],
    RelTableItems:[],
    RelationTableHeader: [
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "کد", value: "code", sortable: true, align: "right" },
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "عنوان ترکیب", value: "ctitle", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "تخفیف ", value: "discount", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    GiftTableHeader:[
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "کد", value: "code", sortable: true, align: "right" },
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "عنوان نمایشی ", value: "newtitle", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "تخفیف ", value: "discount", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    ///
    ///Set Products
    SetProductDialog:false,
    SetProductsSearchByPName:"",
    SetProductsSearchByPCode:"",
    SetAllProductTableItems:[],
    SetTableItems:[],
    CurrentPageSet : 0,
    PageCountsSet: 0 ,
    PageSizeSet: 5,
    ///
      ///pefect product
      PerfectProductDialog:false,
    PageSizePerfect:5,
    PerfectProductsSearchByPName : "",
    PerfectProductsSearchByPCode : "",
    PerfectAllProductTableItems:[],
    PerfectTableItems:[],
    PageCountsPerfect:0,
    CurrentPagePerfect:0,
    ///
///
    ExpertReviewDialog:false,
    ERprodId:0,
    ExpertTitle:"",
    ExpertSort:1,
    ExpertDescription:"",
    ExpertStatus:true,
    ImageUrl:"",
    InEditingExpert : false,
    ExpertTableItems:[],
    ExpertTableHeaders:[
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "عنوان", value: "e_Title", sortable: true, align: "right" },
      { text: "وضعیت", value: "e_Status", sortable: true, align: "right" },
      { text: "عملیات", value: "operation", sortable: true, align: "right" },

    ],
    EditExpertId:0,
    ///
    ///Product Manual
    Psort:1,
    ///
    srchPrdTitle:"",
    srchPrdCode:"",
    tempId:0,
    selectedCat2Id:0,
    ProductAttributeList:[],
    productid:0,
    ProductAttributeDialog:false,
    ProductattributeTableHeader:[
      {text:"صفت" , value:"title" , sortable:false ,  align:"right"},
      {text:"پاسخ" , value:"ans" , sortable:false ,  align:"right"},
    ],
    MainImgFormat:"image/png",
    OldFile:null,
    ResetUploader:false,
    filterByBrandId:0,
    bus:new Vue(),
    ValueableAttributes:[],
    ValueableAttributeModel:[],
    ValueableAttributeModelRepo:[],
    productCode:"",
    Gif:"",
    DetailImages:["",""],
    Catalog:"",
    ExternalSale:false,
    ExternalLink:"",
    TempSelectedCatId:0,
    CombineImage:""
    // ERprodId:0,
    // ExpertReviewDialog:false,
    // ExpertTitle:"",
    // ExpertDescription:"",
    // ExpertSort:1,
    // ImageUrl:"",
    // ExpertStatus:true,
    // InEditingExpert:false,
    // EditExpertId:0
  }),
  computed: {
    LANG() {
      return this.$store.getters.GetLang;
    },
  },
  watch: {
    LANG(nL, oL) {},
  },
  async created() {
    let vm = this;
    // vm.LogoUrl = ApiUrl.PcLogo;
    vm.videoUploadUrl = ApiUrl.uploadDPVideo;
    vm.productMainImageDownloadUrl = ApiUrl.ProductMainImage;
    vm.UploadProductImgUrl = ApiUrl.registerPcImg;
    vm.UploadProductGalleryChildUrl = ApiUrl.registerGalleryChild;
    vm.UploadProductImgEndPoint = "PRDIMG";
    vm.UploadedProductIgGallery = ApiUrl.ProductGalleryImage;
    vm.AudioUrl = ApiUrl.ProductAudio;
    axios.interceptors.request.use(
      (config) => {
        vm.isLoading = true;
        return config;
      },
      (error) => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        vm.isLoading = false;
        return response;
      },
      (error) => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );
    await this.getAllowedMaxLevelCount();
    this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
  },
  methods: {
    async SaveProductPerfects() {
      let vm = this;
    
        let ArrObject = [];
        
        
        vm.PerfectTableItems.forEach((e) => {
          var Model = {};
          Model.X_MainProdId = vm.ProductToSelectRelation;
          Model.X_ProdId = e.id;
          Model.X_CombineId = e.cid;
          ArrObject.push(Model);
        });
        await axios
          .post(ApiUrl.ProductAddPerfect+"/"+vm.ProductToSelectRelation, ArrObject)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              MSGHNDL.OK(data.msg);
              await vm.loadProductsForPerfect();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      
    },

    async deleteExpert(id)
    {
      let vm = this;
      let Model = {};
      Model.E_Id = id;
      await axios
        .post(ApiUrl.ProductExpertReviewDelete, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            await vm.LoadExperts();
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });

    },
    editExpert(Model)
    {
      let vm = this;
      vm.ERprodId = Model.e_ProductId;
      vm.ExpertTitle = Model.e_Title ;
      vm.ExpertDescription = Model.e_Description;
      vm.ExpertSort = Model.e_Sort ;
      vm.ImageUrl = Model.e_Image ;
      vm.ExpertStatus = Model.e_Status;
      vm.InEditingExpert = true;
      vm.EditExpertId = Model.e_Id;
    },
    async DisableExpert(id)
    {
      let vm = this;
      let Model = {};
      Model.E_Id = id;
      await axios
        .post(ApiUrl.ProductExpertReviewDisable, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            await vm.LoadExperts();
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });

    },
    async ActiveExpert(id)
    {
      let vm = this;
      let Model = {};
      Model.E_Id = id;
      await axios
        .post(ApiUrl.ProductExpertReviewActive, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            await vm.LoadExperts();
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });

    },
    async LoadExperts()
    {
      let vm = this;
      await axios.post(ApiUrl.ProductExpertReviewLoad+"/"+vm.ERprodId).then((res)=>{
        var data = res.data;
        if(data.status)
        {
          vm.ExpertTableItems = data.data;
        }
      }).catch((err)=>{console.error("ERROR IN LOADING EXPERTS",err)});
    },
    cancelEditExpert()
    {
      let vm = this;
      vm.ExpertTitle = "";
      vm.ExpertDescription = "";
      vm.ExpertSort = 1;
      vm.ImageUrl = "";
      vm.ExpertStatus = true;
      vm.InEditingExpert = false
    },
    async SaveExpertReview()
    {
      let vm = this;
      var Model = {};
      Model.E_ProductId = vm.ERprodId;
      Model.E_Title = vm.ExpertTitle;
      Model.E_Description = vm.ExpertDescription;
      Model.E_Sort = vm.ExpertSort;
      Model.E_Image = vm.ImageUrl;
      Model.E_Status = vm.ExpertStatus;
      Model.Lang = vm.LANG;
      var url = ApiUrl.ProductExpertReviewAdd;
      if(vm.InEditingExpert)
      {
        Model.E_Id = vm.EditExpertId;
        url = ApiUrl.ProductExpertReviewUpdate;
      }
      await axios.post(url,Model).then(async (res)=>{
        var data = res.data;
        if(data.status)
        {
          MSGHNDL.OK(data.msg);
          vm.cancelEditExpert();
          await vm.LoadExperts();
        }
        else
        {
          MSGHNDL.ERR(data.msg);
        }
      }).catch((err)=>{
        console.error(err);
      });
    },

    async SetExpertReview(pid)
    {
      this.ERprodId = pid;
      this.ExpertReviewDialog = true;
      await this.LoadExperts();
    },
    RemoveComma()
    {
      return Number(this.CombineGem.toString().split(','));
    },
    FormatValue()
    {
      var oldinp = this.CombineGem;
      var nv = oldinp.toString().split(',').join('');
      this.CombineGem = Number(nv).toLocaleString();
    },
    CloseCombine()
    {
      let vm = this;
      this.CombineDialog = false;
      this.CombineW =0;
      this.CombineC = "";
      this.CombineSort =1;
      this.CombineTitle = "";
      this.CombineP = 0;
      this.CombineGem = 0;
      this.CombineAvl = 0;
      this.CombineD = "";
      this.CombinePriceType = true;
      this.CombineDefault = false;
      this.CombineState = true;
      this.CombineTableItems = [];
      this.CombineCode = "";
    },
     async DecreasePrice()
    {
      let vm = this;
      var m = {};
	m.perc = vm.PercToIncDec;
      await axios
        .post(ApiUrl.DecreasePrice,m)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            vm.ChangePriceDlg = false;
            vm.PercToIncDec = 0;
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });

    },
    async IncreasePrice()
    {
      let vm = this;
      var m = {};
	    m.perc = vm.PercToIncDec;
      await axios
        .post(ApiUrl.IncreasePrice,m)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            vm.ChangePriceDlg = false;
            vm.PercToIncDec = 0;
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });

    },
    ExportExcelByCat()
    {
      let vm = this;
      window.open(ApiUrl.DownloadExcel+vm.selectedEndlvlCat+'/'+vm.selectedBrandId,'_blank');
    },
    onEditorChange({ quill, html, text })
    {
      let vm = this;
      vm.ProductIntroduction = html;
    },
     GetUploadedFileName(fn)
    {
      let vm = this;
      vm.CatImageName = fn;
    },
    async GetProductAttributes(pid) {
      let vm = this;
      await axios
        .post(ApiUrl.GetProductAttr+pid)
        .then((res) => {
          let data = res.data;
          if (data.status) {
              vm.ProductAttributeList = data.data;
              console.warn(vm.ProductAttributeList,data.data);
            }
            else
            {
              MSGHNDL.ERR(data.msg);
            }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async ProductAttributes(pid,title)
    {
      let vm = this;
      vm.productid = pid;
      vm.prdTitle = title;
      vm.ProductAttributeDialog = true;
      await vm.GetProductAttributes(pid);
    },
    async SetProductAttributes()
    {
      var vm = this;
      var answers = vm.ProductAttributeList;
      var ans=[];
       answers.forEach(function(item){
         delete item.answers;
         delete item.title;
         ans.push(item);
      });
      var data = new FormData();
      data.append('data',JSON.stringify(ans));
      
        await axios.post(ApiUrl.SetProductAttr,data).then(async (res)=>{
          var data = res.data;
          if(data.status)
          {
            MSGHNDL.OK(data.msg);
            await vm.GetProductAttributes(vm.productid);
          }
          else
          {
            MSGHNDL.ERR(data.msg)
          }
        }).catch((err)=>{console.error(err);MSGHNDL.ERR(err)});
    },
    async SearchProducts()
    {
      let vm = this;
      let title = vm.srchPrdTitle;
      let code = vm.srchPrdCode;
      vm.isLoadingProducts = true;
      await axios
        .post(ApiUrl.SearchProduct + "/" + title + "/" + code)
        .then((res) => {
          vm.isLoadingProducts = false;
          let data = res.data;
          console.warn(data);
          if (data.status) {
            vm.productTableItems = data.data;
            console.warn(data.data);
          }
        })
        .catch((err) => {
          vm.isLoadingProducts = false;
          console.error(err);
        });
    },
    currencyFormat(v)
    {
      
      return (moneyFormat(v));
    },
    async DeleteProductManual()
    {
      let vm = this;
      var Model = {};
      Model.M_ProductId = vm.ProductIdForManual;
      await axios.post(ApiUrl.DeleteProductManual,Model).then(async (res)=>{
        var data = res.data;
        if(data.status)
        {
          MSGHNDL.OK(data.msg);
          await vm.GetProductManual();
        }
        else
        {
          MSGHNDL.ERR(data.msg);
        }
      }).catch((err)=>{console.error("ERROR IN SAVING PRODUCT MANUAL",err)});
    },
    async GiftProdTableJumpToPage(page)
    {
      
      await this.loadProductsForGift(this.CurrentPageGift);
    },
    async SetProdTableJumpToPage(page)
    {
      await this.loadProductsForSet(page);
    },
    async RelProdTableJumpToPage(page)
    {
      await this.loadProductsForRelation(page);
    },
    DeleteFromRelTable(item)
    {
      let vm = this;
      vm.RelTableItems.splice(vm.RelTableItems.indexOf(item),1);
    },
    DeleteFromGiftTable(item)
    {
      let vm = this;
      vm.GiftTableItems.splice(vm.GiftTableItems.indexOf(item),1);
    },
    DeleteFromSetTable(item)
    {
      let vm = this;
      vm.SetTableItems.splice(vm.SetTableItems.indexOf(item),1);
    },
    ShiftToRelTabl(item)
    {
      let vm = this;
      if(vm.RelTableItems.some(x=>x.id == item.id && x.wid == item.wid && x.cid == item.cid))
      {
        MSGHNDL.ERR("تنوع مورد نظر قبلا اضافه شده است");
      }
      else
      {
        vm.RelTableItems.push(item);
      }
    },
    ShiftToSetTabl(item)
    {
      let vm = this;
      if(vm.SetTableItems.some(x=>x.id == item.id && x.wid == item.wid && x.cid == item.cid))
      {
        MSGHNDL.ERR("تنوع مورد نظر قبلا اضافه شده است");
      }
      else
      {
        vm.SetTableItems.push(item);
      }
    },
    removeNumberSplitter(num)
    {
      num = num+"";
      if(num.indexOf(',') > -1)
      {
        var splitPrice = num.split(',');
        var joinedPrice = splitPrice.join('');
        return joinedPrice;
      }
      return num;
    },
    ShiftToGiftTabl(item)
    {
      let vm = this;
      if(vm.GiftTableItems.length > 0)
      {
        MSGHNDL.ERR("هر محصول تنها میتواند یک محصول هدیه داشته باشد");
        return;
      }
      else if(vm.GiftTableItems.some(x=>x.id == item.id ))
      {
        MSGHNDL.ERR("تنوع مورد نظر قبلا اضافه شده است");
      }
      else
      {
        vm.GiftTableItems.push(item);
      }
    },
    editCombineItem(Model) {
      let vm = this;
      vm.CombineProductId = Model.x_ProductId;
       vm.CombineW = Model.x_Weight;
       vm.CombineImage = Model.x_Image;
      vm.CombineCode = Model.x_CombineCode;
      vm.CombineP = Model.x_Price;
      
      vm.CombineAvl = Model.x_AvailableCount;
      vm.CombineSort = Model.x_Sort;
      vm.CombineTitle = Model.x_Title;
      vm.CombineD = Model.x_Discount;
      vm.CombinePriceType = Model.x_DiscountType == 1 ? true : false; //1 => percentage 2=> (price - discount)
      vm.CombineDefault = Model.x_Default;
      vm.CombineState = Model.x_Status;
      vm.EditCombineId = Model.x_Id;
       vm.InEditingCombineItem = true;
      Model.combineValueableAnswers.forEach(x=>{
        var findIndx = vm.ValueableAttributeModel.findIndex(y=>y.valueAttributeId == x.valueAttributeId);
        vm.ValueableAttributeModel[findIndx].valueableAnswerId = x.valueableAnswerId;
      });
     
    },
    clearCombineForm() {
      let vm = this;
      vm.CombineW = 0;
      vm.CombineP = 0;
      vm.CombineD = 0;
      vm.CombineAvl = 0;
      vm.CombineSort = 1;
      vm.CombineTitle = "";
      vm.CombinePriceType = true;
      vm.CombineDefault = false;
      vm.CombineState = true;
      vm.CombineCode = "";
      vm.CombineImage = "";
      vm.ValueableAttributeModel = vm.ValueableAttributeModelRepo;
      console.warn(vm.ValueableAttributeModelRepo);
      vm.InEditingCombineItem = false;
    },
    async SaveCombine() {
      var vm = this;
      var Model = {};
      Model.X_ProductId = vm.CombineProductId;
      Model.X_WarrantyId = 0;
      Model.X_ColorId = 0;
      Model.X_Price = vm.CombineP;
      Model.X_CombineCode = vm.CombineCode;
      Model.X_AvailableCount = vm.CombineAvl;
      Model.X_Discount = vm.CombineD;
      Model.X_DiscountType = vm.CombinePriceType ? 1 : 2; //1 => percentage 2=> (price - discount)
      Model.X_Default = vm.CombineDefault;
      Model.X_Status = vm.CombineState;
      Model.X_Sort = vm.CombineSort;
      Model.X_Title = vm.CombineTitle;
      Model.X_Weight = vm.CombineW;
      Model.X_Image = vm.CombineImage;
      Model.combineValueableAnswers = vm.ValueableAttributeModel;
      var url = ApiUrl.AddProdCombine;
      if (vm.InEditingCombineItem) {
        url = ApiUrl.UpdateProdCombine;
        Model.X_Id = vm.EditCombineId;
      }
      await axios
        .post(url, Model)
        .then(async (res) => {
          var data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            await vm.LoadComines();
            vm.clearCombineForm();
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async LoadComines() {
      let vm = this;
      var Model = {};
      Model.X_ProductId = vm.CombineProductId;
      await axios
        .post(ApiUrl.LoadProdCombine, Model)
        .then(async (res) => {
          var data = res.data;
          console.warn(data);
          if (data.status) {
            vm.CombineTableItems = data.data;
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async Combine({p_Id,p_Title,p_EndLevelCatId}) {
      let vm = this;
      vm.CombineProductId = p_Id;
      vm.CombineProductTitle = p_Title;
      vm.CombineDialog = true;
      await vm.LoadComines();
      await vm.LoadValueAbleAttributes(p_EndLevelCatId);
    },
    async LoadValueAbleAttributes(cat)
    {
      let vm = this;
      await axios
      .post(ApiUrl.LoadVAttributesByCat+'/'+cat, {})
        .then(async (res) => {
          var data = res.data;
          if (data.status) {
            data.data.forEach(e => {
              vm.ValueableAttributeModel.push({valueableAnswerId:0,valueAttributeId:e.id});
              vm.ValueableAttributeModelRepo.push({valueableAnswerId:0,valueAttributeId:e.id});
            });
            console.warn("COMBINE DATA :::: ",data.data);
            vm.ValueableAttributes = data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  
       async checkAparatVideo() {
      let vm = this;

      vm.aprtSrc =
        "https://www.aparat.com/video/video/embed/videohash/" +
        vm.PickVideoName +
        "/vt/frame";
    },
    async SetRealtion(id) {
      this.ProductToSelectRelation = id;
      this.RelatedProductDialog = true;
      await this.loadProductsForRelation();
    },
   
    async SetProducts(id) {
      this.ProductToSelectRelation = id;
      this.SetProductDialog = true;
      await this.loadProductsForSet();
    },
    async SetPerfect(id) {
      this.ProductToSelectRelation = id;
      this.PerfectProductDialog = true;
      await this.loadProductsForPerfect();
    },
    async SetGiftProducts(id) {
      this.ProductToSelectRelation = id;
      this.GiftProductDialog = true;
       await this.loadProductsForGift();
    },
    ShiftToPerfectTabl(item)
    {
      let vm = this;
      if(vm.PerfectTableItems.some(x=>x.id == item.id && x.cid == item.cid))
      {
        MSGHNDL.ERR("تنوع مورد نظر قبلا اضافه شده است");
      }
      else
      {
        vm.PerfectTableItems.push(item);
      }
    },
    DeleteFromPerfectTable(item)
    {
      let vm = this;
      vm.PerfectTableItems.splice(vm.PerfectTableItems.indexOf(item),1);
    },
    async LoadPerfects()
    {
      let vm = this;
      var Model = {};
      Model.Id = vm.ProductToSelectRelation;
      await axios.post(ApiUrl.ProductGetPerfect,Model)
      .then(res=>{
        let data = res.data;
        if(data.status)
        {
          if(data.data.length > 0)
          {
            vm.PerfectTableItems = [];
            
            data.data.forEach(el => {
              var item = vm.PerfectAllProductTableItems.findIndex(i=>i.id == el.x_ProdId && i.cid == el.x_CombineId);
              vm.PerfectTableItems.push(vm.PerfectAllProductTableItems[item]);
            });
          }
        }
        else
        {
         MSGHNDL.ERR(data.msg);
        }
      })
      .catch(err=>{console.error(err);});
    },

    async LoadSets()
    {
      let vm = this;
      var Model = {};
      Model.Id = vm.ProductToSelectRelation;
      await axios.post(ApiUrl.ProductGetSet,Model)
      .then(res=>{
        let data = res.data;
        if(data.status)
        {
          if(data.data.length > 0)
          {
            vm.SetTableItems = [];
            
            data.data.forEach(el => {
              var item = vm.SetAllProductTableItems.findIndex(i=>i.id == el.x_ProdId && i.wid == el.x_WarrantyId && i.cid == el.x_ColorId);
              vm.SetTableItems.push(vm.SetAllProductTableItems[item]);
            });
          }
        }
        else
        {
         MSGHNDL.ERR(data.msg);
        }
      })
      .catch(err=>{console.error(err);});
    },
    async loadProductsForPerfect(page = 1) {
      let vm = this;
      var url = ApiUrl.LoadProductForRelationTable +"/" +vm.ProductToSelectRelation+"/"+page+"/"+vm.PageSizePerfect;
      if(vm.PerfectProductsSearchByPName != null && vm.PerfectProductsSearchByPName != "")
      {
        url+="/"+vm.PerfectProductsSearchByPName;
      }
      if(vm.PerfectProductsSearchByPCode != null && vm.PerfectProductsSearchByPCode != "")
      {
        url+="/"+vm.PerfectProductsSearchByPCode;
      }
      await axios
        .post(
          url
        )
        .then(async (res) => {

          let data = res.data;
          console.warn(data);
          if (data.status) {
            vm.PerfectAllProductTableItems = data.data.products;
            vm.PageCountsPerfect = data.data.totalPages;
            vm.CurrentPagePerfect = data.data.currentPage;
            vm.RelationDataLoaded = true;
            console.warn("LOADING RELATION DATA",data.data);
            await vm.LoadPerfects();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async LoadGift()
    {
      return;
      let vm = this;
      var Model = {};
      Model.Id = vm.ProductToSelectRelation;
      await axios.post(ApiUrl.ProductGetGift,Model)
      .then(res=>{
        let data = res.data;
        if(data.status)
        {
          if(data.data.length > 0)
          {
            console.warn(data);
            vm.GiftTableItems = [];
            
            data.data.forEach(el => {
              var item = vm.GiftAllProductTableItems.findIndex(i=>i.id == el.x_ProdId );
              var i = vm.GiftAllProductTableItems[item];
              i.newtitle = el.newtitle;
              vm.GiftTableItems.push(i);
            });
          }
        }
        else
        {
         MSGHNDL.ERR(data.msg);
        }
      })
      .catch(err=>{console.error(err);});
    },

    async LoadRelations()
    {
      let vm = this;
      var Model = {};
      Model.Id = vm.ProductToSelectRelation;
      await axios.post(ApiUrl.ProductGetRelations,Model)
      .then(res=>{
        let data = res.data;
        if(data.status)
        {
          if(data.data.length > 0)
          {
            vm.RelTableItems = [];
            
            data.data.forEach(el => {
              var item = vm.RelationAllProductTableItems.findIndex(i=>i.id == el.x_ProdId && i.wid == el.x_WarrantyId && i.cid == el.x_ColorId);
              vm.RelTableItems.push(vm.RelationAllProductTableItems[item]);
            });
          }
        }
        else
        {
         MSGHNDL.ERR(data.msg);
        }
      })
      .catch(err=>{console.error(err);});
    },
    async SaveProductRelations() {
      let vm = this;
 
        let ArrObject = [];
        
        
        vm.RelTableItems.forEach((e) => {
          var Model = {};
          Model.X_MainProdId = vm.ProductToSelectRelation;
          Model.X_ProdId = e.id;
          Model.X_ColorId = e.cid;
          Model.X_WarrantyId = e.wid;
          ArrObject.push(Model);
        });
        await axios
          .post(ApiUrl.ProductAddRelation, ArrObject)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              MSGHNDL.OK(data.msg);
              await vm.loadProductsForRelation();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      
    },
    async SaveProductSet() {
      let vm = this;
    
        let ArrObject = [];
        
        
        vm.SetTableItems.forEach((e) => {
          var Model = {};
          Model.X_MainProdId = vm.ProductToSelectRelation;
          Model.X_ProdId = e.id;
          Model.X_ColorId = e.cid;
          Model.X_WarrantyId = e.wid;
          ArrObject.push(Model);
        });
        await axios
          .post(ApiUrl.ProductAddSet+"/"+vm.ProductToSelectRelation, ArrObject)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              MSGHNDL.OK(data.msg);
              await vm.loadProductsForSet();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      
    },
    async SaveProductGift() {
      let vm = this;
      
        let ArrObject = [];
        
        
        vm.GiftTableItems.forEach((e) => {
          var Model = {};
          Model.X_MainProdId = vm.ProductToSelectRelation;
          Model.X_ProdId = e.id;
          Model.X_ColorId = e.cid;
          Model.X_WarrantyId = e.wid;
          Model.newtitle = e.newtitle;
          ArrObject.push(Model);
        });
        await axios
          .post(ApiUrl.ProductAddGift+"/"+vm.ProductToSelectRelation, ArrObject)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              MSGHNDL.OK(data.msg);
              await vm.loadProductsForGift();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      
    },

    async DeleteItem() {
      let vm = this;
      vm.deleteBtnLoading = true;
      let Model = {};
      Model.P_Id = vm.deleteItemId;
      await axios
        .post(ApiUrl.DeleteProduct, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            vm.ConfirmItemDeleteDialog = false;
            vm.productTableItems = [];
            vm.srchPrdCode = "";
            vm.srchPrdTitle = "";
            vm.loadProducts(vm.tempId);
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });
    },
    confirmDeleteItem(id) {
      this.deleteItemId = id;
      this.ConfirmItemDeleteDialog = true;
    },
    editItem(Model) {
      let vm = this;
      vm.editingItem = Model;
      vm.inEditingItem = true;
      vm.productBrand = Model.p_BrandId;
      vm.productLabel = [];
      
      if(Model.labels.length > 0)
      {
         Model.labels.forEach(x=> {console.warn("LABEL ID : ",x.x_LabelId);vm.productLabel.push(x.x_LabelId);});
      }
      
      vm.productCode = Model.p_Code;
      vm.productUniqueCode = Model.p_EnTitle;
      vm.manualRate = Model.manualRate;
      vm.productTitle = Model.p_Title;
      vm.CatImageName = Model.p_Image;
      vm.Gif = Model.p_Gif;
      vm.catLogoData = Model.p_Image;
      vm.NewProdCatChanged(2, Model.p_MainCatId);
      vm.ProductTechnicalInfo = Model.p_Description;
      vm.SummeryDescription = Model.p_SummeryDescription;
      vm.ProductDesc2 = Model.p_Description2;
      vm.productWeight = Model.p_Weight;
      vm.productVolume = Model.p_Volume;
      vm.PickVideoName = Model.p_Video;
      vm.Psort = Model.p_Sort;
      var spl = Model.p_ImgGallery.split(",");
      if(spl.length > 0 )
      {
        if(spl.length == 1)
        {
          if(spl[0] != "" && spl[0] != null && spl[0].length > 1)
          {
            vm.imageItems = Model.p_ImgGallery.split(",");
          }
        }
        else
        {
          vm.imageItems = Model.p_ImgGallery.split(",");
        }
      }
      vm.DetailImages = Model.p_ContentImage.split(',');
      vm.Catalog = Model.p_Catalog;
      vm.ExternalSale = Model.p_ExternalSale;
      vm.ExternalLink = Model.p_ExternalLink;
      vm.productDetailTitle = Model.p_DetailsTitle ;
      vm.ProdStatus = Model.p_Status;
      vm.PrdSeoModel = JSON.parse(Model.p_Seo);
      vm.seo = JSON.parse(Model.p_Seo);
      vm.NewProdCatModels = vm.FooterCategoryModel;
      vm.NewProdCatModels["cat1"] = Model.p_MainCatId;
      vm.NewProdCatModels["cat" + vm.MAXCATLEVELCOUNT] = Model.p_EndLevelCatId;
     
      // var fields = JSON.parse(Model.p_DedicatedField);
     

      vm.checkAparatVideo();
      for (var i = 1; i <= vm.MAXCATLEVELCOUNT; i++) {
        vm.getProdcutCatAtributes(vm.FooterCategoryModel["cat" + i]);
        // vm.
      }
    },
    async SaveProduct() {
      let vm = this;
      let Model = {};
      Model.P_Seo = JSON.stringify(vm.seo);
      Model.P_MainCatId = parseInt(vm.NewProdCatModels["cat1"]);
      Model.P_EndLevelCatId = parseInt(
        vm.NewProdCatModels["cat" + vm.MAXCATLEVELCOUNT]
      );
      Model.P_EnTitle = vm.productUniqueCode;
      Model.P_BrandId = vm.productBrand;
      Model.P_LabelIds = vm.productLabel;
      Model.P_Code = vm.productCode;
      Model.P_Title = vm.productTitle;
      Model.ManualRate = vm.manualRate;
      Model.P_Weight = vm.productWeight;
      Model.P_Volume = vm.productVolume;
      Model.P_Image = vm.CatImageName;
      Model.P_Gif = vm.Gif;
      Model.P_Status = vm.ProdStatus;
      Model.P_Sort = vm.Psort;
      Model.P_DetailsTitle = vm.productDetailTitle;
      var se = (vm.seo);
            if(se.url  == "" || se.url == null || se.url.length < 1)
            {
                MSGHNDL.ERR("Url  محصول الزامی میباشد");
                return;
            }
      
      Model.P_Url = vm.seo.url;
      Model.P_ImgGallery = vm.imageItems.join(",");
      Model.P_ContentImage = vm.DetailImages.join(',');
      Model.P_Catalog = vm.Catalog;
      Model.P_ExternalSale = vm.ExternalSale;
      Model.P_ExternalLink = vm.ExternalLink;
      Model.P_Video = vm.PickVideoName;
      Model.P_Description = vm.ProductTechnicalInfo;
      Model.P_SummeryDescription = vm.SummeryDescription;
      Model.P_Description2 = vm.ProductDesc2;
      Model.P_Type = 1;
     
      var url = ApiUrl.registerProduct;
      if (vm.inEditingItem) {
        Model.P_Id = vm.editingItem.p_Id;
 
        url = ApiUrl.updateProduct;
      }

      await axios
        .post(url, Model)
        .then(async (res) => {
          let data = res.data;
          console.warn(data);
          if (data.status) {
             vm.loadProducts(vm.TempSelectedCatId);
            vm.cancelEditItem();
             vm.NewProductStep = 1;
             if(vm.inEditingItem)
             {
               vm.productTableItems = [];
             }
            MSGHNDL.OK(data.msg);
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
      
      console.warn(Model);
    },
    cancelEditItem() {
      let vm = this;
      vm.aprtSrc = "";
      vm.inEditingItem = false;
      vm.manualRate = 0;
      vm.productWeight = 0;
      vm.productVolume = 0;
      vm.Catalog = "";
      vm.ExternalSale = false;
      vm.ExternalLink = "";
      vm.PickVideoName = "";
      vm.ProductTechnicalInfo = "";
      vm.SummeryDescription = "";
      vm.ProductDesc2 = "";
      vm.NewProdCatModels = [];
      vm.productBrand = "";
      vm.Psort = 1;
      vm.productLabel = [];
      vm.productCode = "";
      vm.productTitle = "";
      vm.productIsbn = "";
      vm.productDetailTitle = "";
      vm.productDetailSubTitle = "";
      vm.CatImageName = "";
      vm.Gif = "";
      vm.ProdStatus = true;
      vm.PrdSeoModel = {};
      vm.imageItems = [];
      vm.DetailImages = ["",""];
      vm.Catalog= "";
      vm.ExternalSale = flase;
      vm.ExternalLink = "";
      vm.ProductIntroduction = "";
      vm.ProductTechnicalInfo = "";
      vm.SummeryDescription = "";
      vm.ProductDesc2 = "";
      vm.productPrice = 0;
      vm.productDiscount = 0;
      vm.DiscountType = true;
      vm.productAmazonPrice = 0;
      vm.SelectedAttributes = [];
      vm.Attributes = [];
      vm.aprtSrc = "";
      vm.productUniqueCode = "";
      vm.manualRate = 0;
      vm.productWeight = 0;
      vm.productVolume = 0;
      vm.OldFile = "";
      vm.srchPrdTitle = "";
      vm.srchPrdCode = "";
      vm.seo = Object.assign({},{title:"",
      url:"",
      keywords:"",
      image:"",
      description:"",
      othermeta:""});
      vm.PrdSeoModel = Object.assign({},{title:"",
      url:"",
      keywords:"",
      image:"",
      description:"",
      othermeta:""});
      vm.$refs.MainImg.resetUploaderEXT();
    },
    async DisableItem(id) {
      let vm = this;
      let Model = {};
      Model.P_Id = id;
      await axios
        .post(ApiUrl.DisableProduct, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            vm.loadProducts(vm.tempId);
           
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });
    },
    async DisableCombineItem(id) {
      let vm = this;
      let Model = {};
      Model.X_Id = id;
      await axios
        .post(ApiUrl.DisablerodCombine, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            await vm.LoadComines();
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });
    },
    async DeleteCombineItem(id) {
      let vm = this;
      let Model = {};
      Model.X_Id = id;
      await axios
        .post(ApiUrl.DeleteProdCombine, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            await vm.LoadComines();
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });
    },
    async ActiveCombineItem(id) {
      let vm = this;
      let Model = {};
      Model.X_Id = id;
      await axios
        .post(ApiUrl.ActiveProdCombine, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            await vm.LoadComines();
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });
    },
    async ActiveItem(id) {
      let vm = this;
      let Model = {};
      Model.P_Id = id;
      await axios
        .post(ApiUrl.ActiveProduct, Model)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            MSGHNDL.OK(data.msg);
            vm.loadProducts(vm.tempId);
          } else {
            MSGHNDL.ERR(data.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });
    },

    
    async NewProdCatChanged(lvl, val) {
      let vm = this;
      if (lvl <= vm.MAXCATLEVELCOUNT) {
        let Model = {};
        Model.Id = val;
        let index = "cat" + lvl;
        await axios
          .post(ApiUrl.getCategoryChilds, Model)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              vm.$data["NewProdCatItems"][index] = data.data.childs;
              await vm.getProdcutCatAtributes(val);
              console.warn(data.data.attributes);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        await vm.getProdcutCatAtributes(val, true);
      }
    },
    async getProdcutCatAtributes(val, lastIndex = false) {
      let vm = this;
      let Model = {};
      Model.Id = val;
      await axios
        .post(ApiUrl.getCategoryAttributes, Model)
        .then((res) => {
          let data = res.data;
          if (data.status) {
            for (var i = 0; i < data.data.length; i++) {
              if (vm.SelectedAttributes !=null && vm.SelectedAttributes.length > 0 && !vm.SelectedAttributes.some((e) => e.id == data.data[i].id)) {
                vm.SelectedAttributes.push({ id: data.data[i].id, value: "" });
              }
              if (!vm.Attributes.some((e) => e.id == data.data[i].id)) {
                vm.Attributes.push(data.data[i]);
              }
            }
            console.warn(vm.SelectedAttributes);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    removeDuplicates(originalArray, prop) {
      var newArray = [];
      var lookupObject = {};

      for (var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
      }

      for (i in lookupObject) {
        newArray.push(lookupObject[i]);
      }
      return newArray;
    },
    async CatSelectionChanged(lvl, val) {
      let vm = this;
      if (lvl <= vm.MAXCATLEVELCOUNT) {
        let Model = {};
        Model.Id = val;
        let index = "cat" + lvl;
        await axios
          .post(ApiUrl.getCategoryChilds, Model)
          .then((res) => {
            let data = res.data;
            if (data.status) {
              vm.$data["CategoryItems"][index] = data.data;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
      }
    },
    async RelatedCatSelectionChanged(lvl, val) {
      let vm = this;

      if (lvl <= vm.MAXCATLEVELCOUNT) {
        let Model = {};
        Model.Id = val;
        let index = "cat" + lvl;
        await axios
          .post(ApiUrl.getCategoryChilds, Model)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              vm.$data["RelatedCategoryItems"][index] = data.data.childs;
              console.warn("data:", data.data.childs);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        await vm.loadProductsForRelation(val);
      }
    },
    async FooterCatSelectionChanged(lvl, val) {
      let vm = this;
      if (lvl <= vm.MAXCATLEVELCOUNT) {
        let Model = {};
        Model.Id = val;
        let index = "cat" + lvl;
        await axios
          .post(ApiUrl.getCategoryChilds, Model)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              vm.$data["FooterCategoryItems"][index] = data.data.childs;
              console.warn("data:", data.data.childs);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        vm.tempId = val;
        vm.selectedEndlvlCat = val;
        // await vm.loadProducts(val);
      }
    },
    async loadProductsForRelation(page = 1) {
      let vm = this;
      vm.isLoadingRelatedProducts = true;
      var url = ApiUrl.LoadProductForRelationTable +"/" +vm.ProductToSelectRelation+"/"+page+"/"+vm.PageSize;
      if(vm.RelationProductsSearchByPName != null && vm.RelationProductsSearchByPName != "")
      {
        url+="/"+vm.RelationProductsSearchByPName;
      }
      if(vm.RelationProductsSearchByPCode != null && vm.RelationProductsSearchByPCode != "")
      {
        url+="/"+vm.RelationProductsSearchByPCode;
      }
      await axios
        .post(
          url
        )
        .then(async (res) => {

          vm.isLoadingRelatedProducts = false;
          let data = res.data;
          console.warn(data);
          if (data.status) {
            vm.RelationAllProductTableItems = data.data.products;
            vm.PageCounts = data.data.totalPages;
            vm.CurrentPage = data.data.currentPage;
            vm.RelationDataLoaded = true;
            console.warn("LOADING RELATION DATA",data.data);
            await vm.LoadRelations();
          }
        })
        .catch((err) => {
          vm.isLoadingRelatedProducts = false;
          console.error(err);
        });
    },
     loadProductsForGift(page = 1) {
      let vm = this;
      
      var url = ApiUrl.LoadProductForRelationTable +"/" +vm.ProductToSelectRelation+"/"+page+"/"+vm.PageSizeGift;
      if(vm.GiftProductsSearchByPName != null && vm.GiftProductsSearchByPName != "")
      {
        url+="/"+vm.GiftProductsSearchByPName;
      }
      if(vm.GiftProductsSearchByPCode != null && vm.GiftProductsSearchByPCode != "")
      {
        url+="/"+vm.GiftProductsSearchByPCode;
      }

       axios
        .post(
          url
        )
        .then( function(res)  {

          var data = res.data;          
          if (data.status) {
            vm.GiftAllProductTableItems = data.data.products.list;
            vm.PageCountsGift = data.data.totalPages;
            vm.CurrentPageGift = data.data.currentPage;
            
               vm.LoadGift();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    async loadProductsForSet(page = 1) {
      let vm = this;
      var url = ApiUrl.LoadProductForRelationTable +"/" +vm.ProductToSelectRelation+"/"+page+"/"+vm.PageSizeSet;
      if(vm.SetProductsSearchByPName != null && vm.SetProductsSearchByPName != "")
      {
        url+="/"+vm.SetProductsSearchByPName;
      }
      if(vm.SetProductsSearchByPCode != null && vm.SetProductsSearchByPCode != "")
      {
        url+="/"+vm.SetProductsSearchByPCode;
      }
      await axios
        .post(
          url
        )
        .then(async (res) => {

          let data = res.data;
          console.warn(data);
          if (data.status) {
            vm.SetAllProductTableItems = data.data.products;
            vm.PageCountsSet = data.data.totalPages;
            vm.CurrentPageSet = data.data.currentPage;
            vm.RelationDataLoaded = true;
            console.warn("LOADING RELATION DATA",data.data);
             await vm.LoadSets();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
   
   
    async loadProducts(val) {
      let vm = this;
      vm.TempSelectedCatId = val;
      vm.isLoadingProducts = true;
      await axios
        .post(ApiUrl.LoadProduct + "/" + val+"/"+vm.filterByBrandId + "/" + vm.LANG)
        .then((res) => {
          vm.isLoadingProducts = false;
          let data = res.data;
          console.warn(data);
          if (data.status) {
            vm.productTableItems = data.data;
            console.warn(data.data);
          }
        })
        .catch((err) => {
          vm.isLoadingProducts = false;
          console.error(err);
        });
    },
    async getAllowedMaxLevelCount() {
      let vm = this;

      await axios
        .post(ApiUrl.getCategoiesOfLevelOne)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            vm.MAXCATLEVELCOUNT = data.data.max;
            for (let i = 1; i <= vm.MAXCATLEVELCOUNT; i++) {
              let index = `cat${i}`;
              vm.CategoryItems[index] = [];
              vm.FooterCategoryItems[index] = [];
              vm.RelatedCategoryItems[index] = [];
              vm.CatSelectionModels[index] = "";
            }
            vm.CategoryItems["cat1"] = data.data.cats;
            vm.FooterCategoryItems["cat1"] = data.data.cats;
            vm.NewProdCatItems["cat1"] = data.data.cats;
            vm.RelatedCategoryItems["cat1"] = data.data.cats;
            await vm.getBrands();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getBrands() {
      let vm = this;

      await axios
        .post(ApiUrl.LoadBrandComboItems + "/" + vm.LANG)
        .then(async (res) => {
          let data = res.data;
          if (data.status) {
            vm.BrandItems = data.data;
            await vm.getLabels();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getLabels() {
      let vm = this;

      await axios
        .post(ApiUrl.LoadLabelCpmboItems + "/" + vm.LANG)
        .then((res) => {
          let data = res.data;
          if (data.status) {
            vm.LabelItems = data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    SeoChanged(data) {
      console.warn("Passed Seo Data:",data);
      this.seo = data;
    },
    async deleteImageItem(item) {
       let vm = this;
      vm.imageItems = vm.imageItems.filter((i) => i !== item);
      await axios
        .post(ApiUrl.removeNoticesGalleryChild, {
          DataUrl: item,
          Loc: vm.UploadProductImgEndPoint,
        })
        .then((res) => {
          if (res.data.status) {
            MSGHNDL.OK(res.data.msg);
            
          } else {
           
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    PickImageName(fname) {
      this.imageItems.push(fname);
    },
  },
};
</script>
<style>
.theme--light.v-input input, .theme--light.v-input textarea
{
  direction: rtl !important;
}
.videoHolderAndSelect {
  display: block;
  min-height: 430px;
  max-height: 430px;
  position: relative;
  background: transparent;
}
.v-stepper__step--inactive .v-stepper__label {
  color: rgba(255, 255, 255, 0.13) !important;
}
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: rgb(57, 64, 88) !important;
}
.operationBoxButton,
.OperationBoxColumns {
  margin-right: 5px;
}
.OperationBoxColumns {
  max-width: 200px;
  display: flex;
  align-items: center;
  padding-top: 10px;
}
.operationBoxDesign {
  display: flex;
  align-items: center;
  border-radius: 0px;
  justify-content: start;
  min-height: 50px;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
  /* border: 1px solid rgb(207, 207, 207); */
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(207, 207, 207, 0.5);
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>